import React from 'react';
import { useIntl } from "react-intl";
import PropTypes from 'prop-types';
import useFetch from "../../../hooks/useFetch";
import { Form as FinalForm } from 'react-final-form';
import { getIntegrationCookiebot, updateIntegrationCookiebot } from "../../../redux/methods/integrations";
import { connect } from 'react-redux';
import ContainerWithCard from '../../../components/ContainerWithCard';
import { Container, Form, Row } from 'reactstrap';
import SectionEditFormButtons from '../../../components/SectionEditFormButtons';
import FormFieldTextarea from '../../../components/formFields/FormFieldTextarea';
import FormFieldTextOrNumber from '../../../components/formFields/FormFieldTextOrNumber';
import FormFieldSwitchPill from '../../../components/formFields/FormFieldSwitchPill';

const propTypes =
{
    getIntegrationCookiebot: PropTypes.func,
    updateIntegrationCookiebot: PropTypes.func,
};

/**
 * @typedef CookiebotProperties
 * @property {Connectico.Integration.Cookiebot.CookiebotSettings} getIntegrationCookiebot
 */

/**
 * @param {CookiebotProperties} param0
 */
export function Cookiebot({ getIntegrationCookiebot, updateIntegrationCookiebot })
{
    const intl = useIntl();
    const translations = intl.messages.integrations.cookiebot;
    const [ data ] = useFetch(getIntegrationCookiebot);
    return data ? (
        <ContainerWithCard title={translations.title} iconClass='fa fa-cookie-bite'>
            <FinalForm
                keepDirtyOnReinitialize
                initialValues={data}
                onSubmit={updateIntegrationCookiebot}
                render={({ handleSubmit, form }) =>
                    <Form onSubmit={handleSubmit}>
                        <Container fluid>
                            <Row className='mb-3'>
                                <FormFieldSwitchPill name='enabled' label={translations.labels.enabled} className='w-100 me-3' />
                            </Row>
                            <Row className='mb-3'>
                                <FormFieldTextOrNumber name='id' label={translations.labels.id} className='w-100 me-3' />
                            </Row>
                            <Row className='mb-3'>
                                <FormFieldTextarea name='script' label={translations.labels.script} className='w-100 me-3' />
                            </Row>
                            <SectionEditFormButtons formReset={form.reset} onSubmit={handleSubmit}/>
                        </Container>
                    </Form>
                }
            >
            </FinalForm>
        </ContainerWithCard>)
    : (<ContainerWithCard title={translations.title} iconClass='fa fa-cookie-bite'></ContainerWithCard>);
}

const mapDispatch =
{
    getIntegrationCookiebot,
    updateIntegrationCookiebot,
};

Cookiebot.propTypes = propTypes;
export default connect(null, mapDispatch)(Cookiebot);